import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { getProductAction } from '@finect/front-resources/Products';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Icon } from '../../../Icon';
import { CardInfo, CardColumns, CardTitle, OrganizationName, ActionsColumn, HeadlineInfo, CardMainContent, ButtonArrow, ActionLink, AggregatedBadge, AggregatedBadgeText } from './partials';
export var FeaturedProductDistributor = function FeaturedProductDistributor(_ref) {
  var product = _ref.product,
    commercialization = _ref.commercialization,
    totalCards = _ref.totalCards,
    onAction = _ref.onAction,
    onSecondaryAction = _ref.onSecondaryAction,
    _ref$userBank = _ref.userBank,
    userBank = _ref$userBank === void 0 ? null : _ref$userBank,
    userBankState = _ref.userBankState,
    _ref$isPartner = _ref.isPartner,
    isPartner = _ref$isPartner === void 0 ? false : _ref$isPartner;
  var organization = commercialization.organization,
    description = commercialization.description;
  var url = "".concat(isPartner ? getSuperPartnerBaseURL() : '').concat(organization.web);
  var iconURL = organization.icon ? "https://www.finect.com/image/".concat(organization.icon) : null;
  var fetched = userBankState.fetched,
    fetching = userBankState.fetching;
  return React.createElement(CardInfo, {
    single: totalCards === 1,
    bottomMargin: true,
    isAggregated: Boolean(userBank)
  }, React.createElement(AggregatedBadge, null, fetched && !fetching && userBank ? React.createElement(AggregatedBadgeText, null, "Enlazado") : React.createElement("span", null)), React.createElement(CardColumns, null, React.createElement(CardMainContent, null, React.createElement(Icon, {
    type: organization.subtype,
    size: 4,
    alt: organization.displayName,
    image: iconURL,
    margin: "0 18px 0 0",
    aditionalIcon: null,
    withBorder: true,
    url: url
  }), React.createElement(CardTitle, null, React.createElement(OrganizationName, {
    href: url
  }, organization.displayName), React.createElement(HeadlineInfo, null, React.createElement(ParagraphSmall, {
    light: true
  }, description ? description : 'Invierte en los mejores fondos con el menor coste'))))), fetched && !fetching ? React.createElement(ActionsColumn, null, !userBank && React.createElement(ActionLink, {
    onClick: onSecondaryAction
  }, 'Enlazar cuenta'), React.createElement("div", null, React.createElement(ButtonArrow, {
    variant: "medium",
    width: "auto",
    onClick: onAction,
    disabled: userBank && userBank.status === 'new'
  }, userBank ? getProductAction(product).action : 'Abrir cuenta', React.createElement(ArrowRight, {
    size: "16"
  })))) : React.createElement(ActionsColumn, null, React.createElement(ActionLink, {
    onClick: onSecondaryAction
  }, 'Enlazar cuenta'), React.createElement("div", null, React.createElement(ButtonArrow, {
    variant: "medium",
    width: "auto",
    onClick: onAction
  }, 'Abrir cuenta', React.createElement(ArrowRight, {
    size: "16"
  })))));
};